module.exports = __webpack_public_path__ + "static/media/logo_ABBank.93691f6b.svg";